module.exports = __webpack_public_path__ + "img/statement_settings.1983f808.svg";